import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { User } from '@/store/user'
import { userQueryKey, getCurrentUser } from '@/lib/actions.ts'

/** Per-observer overrides, for a screen that needs me fresher than the rest of the app does. */
export type FetchUserOptionsT = Pick<
  UseQueryOptions<User, Error>,
  'enabled' | 'staleTime' | 'refetchOnMount' | 'refetchOnWindowFocus'
>

export const useFetchUser = (options: FetchUserOptionsT = {}): UseQueryResult<User, Error> => {
  return useQuery<User, Error>({
    queryKey: userQueryKey,
    queryFn: getCurrentUser,
    // Don't throw on error - let ProtectedRoute handle offline/error states gracefully
    // This prevents the error boundary from catching network errors on cold start
    throwOnError: false,
    ...options,
  })
}
